<template>
    <div>
      <div class="calcul">
        <!-- 시간(초) 내용 -->
        <div v-show="selectedType === 1">
          <div class="screen">
            <div class="screen-box">
              <div class="screen-unit" id="naturalNum1">
                <span class="screen-unit-bar bar1"></span>
                <span class="screen-unit-bar bar2"></span>
                <span class="screen-unit-bar bar3"></span>
                <span class="screen-unit-bar bar4"></span>
                <span class="screen-unit-bar bar5"></span>
                <span class="screen-unit-bar bar6"></span>
                <span class="screen-unit-bar bar7"></span>
              </div>
              <select v-model="naturalNum" id="naturalSelect">
                <option v-for="n in naturalNumOptions" :key="n" :value="n">{{ n }}</option>
              </select>
            </div>
            <div class="screen-box">
              <div class="screen-unit" id="naturalNum2">
                <span class="screen-unit-bar bar1"></span>
                <span class="screen-unit-bar bar2"></span>
                <span class="screen-unit-bar bar3"></span>
                <span class="screen-unit-bar bar4"></span>
                <span class="screen-unit-bar bar5"></span>
                <span class="screen-unit-bar bar6"></span>
                <span class="screen-unit-bar bar7"></span>
              </div>
            </div>
            <span class="unit"></span>
            <div class="screen-box">
              <div class="screen-unit" id="decimalNum">
                <span class="screen-unit-bar bar1"></span>
                <span class="screen-unit-bar bar2"></span>
                <span class="screen-unit-bar bar3"></span>
                <span class="screen-unit-bar bar4"></span>
                <span class="screen-unit-bar bar5"></span>
                <span class="screen-unit-bar bar6"></span>
                <span class="screen-unit-bar bar7"></span>
              </div>
              <select v-model="decimalNum" id="decimalSelect">
                <option v-for="n in decimalNumOptions" :key="n" :value="n">{{ n }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <p class="txt-help">※ 숫자를 눌러 값을 변경해 보세요.</p>
  
      <div class="goal-div" v-show="showGoalDiv">
        <h3>예상 기록</h3>
        <ul>
          <li v-for="(time, key) in calculatedTimes" :key="key">
            <span>{{ key }}</span>
            <strong>{{ time }}</strong>
          </li>
        </ul>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "TreadmillCalculator",
    data() {
      return {
        selectedType: 1,
        naturalNum: 10,
        decimalNum: 0,
        naturalNumOptions: this.generateOptions(0, 30),
        decimalNumOptions: this.generateOptions(0, 9),
        showGoalDiv: false,
        calculatedTimes: {}
      };
    },
    watch: {
      naturalNum(newValue, oldValue) {
        this.startCounting(oldValue, newValue, 'naturalNum');
      },
      decimalNum(newValue, oldValue) {
        this.startCounting(oldValue, newValue, 'decimalNum');
      }
    },
    methods: {
      generateOptions(start, end) {
        const options = [];
        for (let i = start; i <= end; i++) {
          options.push(i);
        }
        return options;
      },
      startCounting(oldValue, newValue, type) {
        if (this.countInterval) {
          clearInterval(this.countInterval);
        }
  
        let currentValue = oldValue;
        const increment = newValue > oldValue ? 1 : -1;
        const updateCount = () => {
          if (currentValue !== newValue) {
            currentValue += increment;
            if (type === 'naturalNum') {
              this.updateDisplay(currentValue, this.decimalNum);
            } else {
              this.updateDisplay(this.naturalNum, currentValue);
            }
          } else {
            clearInterval(this.countInterval);
            this.calculateTimes(); // 새로운 속도로 시간 계산
          }
        };
        this.countInterval = setInterval(updateCount, 50);
      },
      updateDisplay(naturalNum, decimalNum) {
        this.showGoalDiv = true;
        const naturalNumStr = naturalNum.toString().padStart(2, '0');
        const naturalNum1Value = parseInt(naturalNumStr.charAt(0));
        const naturalNum2Value = parseInt(naturalNumStr.charAt(1));
  
        this.clearDisplay();
        this.digitalNum("naturalNum1", naturalNum1Value);
        this.digitalNum("naturalNum2", naturalNum2Value);
        this.digitalNum("decimalNum", decimalNum);
      },
      clearDisplay() {
        const elements = document.querySelectorAll(".screen-unit-bar");
        elements.forEach(el => el.classList.remove("on"));
      },
      digitalNum(elementId, value) {
        const selectElement = document.getElementById(elementId);
        const selectElementUnit = selectElement.querySelectorAll(".screen-unit-bar");
  
        const barMapping = {
          0: [0, 1, 2, 4, 5, 6],
          1: [2, 5],
          2: [0, 2, 3, 4, 6],
          3: [0, 2, 3, 5, 6],
          4: [1, 2, 3, 5],
          5: [0, 1, 3, 5, 6],
          6: [0, 1, 3, 4, 5, 6],
          7: [0, 2, 5],
          8: [0, 1, 2, 3, 4, 5, 6],
          9: [0, 1, 2, 3, 5],
        };
  
        if (barMapping[value]) {
          barMapping[value].forEach(index => {
            selectElementUnit[index].classList.add("on");
          });
        }
      },
      calculateTimes() {
        const speed = this.naturalNum + this.decimalNum / 10; // 시속 계산
        const distances = {
            "400m": 0.4,
            "1km": 1,
            "3km": 3,
            "5km": 5,
            "10km": 10,
            "half": 21.0975, // 하프 마라톤
            "full": 42.195 // 풀 마라톤
        };
        const times = {};

        for (let key in distances) {
            const distance = distances[key];
            const timeInSeconds = (distance / speed) * 3600;

            if (key === "400m") {
            times[key] = `${timeInSeconds.toFixed(1)} 초`;
            } else {
            const hours = Math.floor(timeInSeconds / 3600);
            const minutes = Math.floor((timeInSeconds % 3600) / 60);
            let seconds = Math.floor(timeInSeconds % 60);

            // 초와 분이 한자리일 경우 앞에 0 추가
            const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;
            const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

            let timeString = '';
            if (hours > 0) timeString += `${hours}h`;
            timeString += `${formattedMinutes}'`;
            timeString += `${formattedSeconds}"`; // 초는 항상 표시

            times[key] = timeString.trim();
            }
        }

        this.calculatedTimes = times;
        }



    },
    mounted() {
      this.updateDisplay(this.naturalNum, this.decimalNum);
      this.calculateTimes(); // 초기 로딩 시 계산
    },
    beforeUnmount() {
      if (this.countInterval) {
        clearInterval(this.countInterval);
      }
    }
  };
  </script>
  
  
  
  

<style scoped>
.calcul {
  border-radius: 0.8em;
}
.screen{
    display: flex;
    justify-content: center;
    gap: 10px;
    align-items: end;
}
.screen-box{
    width: 110px;
    height: 150px;
    background: #000;
    border-radius: 10px;
    position: relative;
}
.screen-box select{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: transparent;
    color: transparent;
    border: transparent;
    z-index: 2;
}
.screen-box:first-child select{
    width: calc(200% + 10px);
}
.screen-unit{
    width: 110px;
    height: 150px;
    position: absolute;
    left: calc(50% - 65px);
    top: 0;
}
.screen-unit-bar{
    position: absolute;
    width: 60px;
    height: 10px;
    background: #333;
    left: 35px;
    top: 20px;
}
.screen-unit-bar.on{
    background: #fbff00;
}
.screen-unit-bar.on:before{
    border-right-color: #fbff00;
}
.screen-unit-bar.on:after{
    border-left-color: #fbff00;
}
.screen-unit-bar:before,
.screen-unit-bar:after{
    content: '';
    display: block;
    position: absolute;
    width: 0; 
    height: 0; 
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent; 
    border-right:5px solid #333; 
    left: -5px;
}
.screen-unit-bar:after{
    left: auto;
    right: -5px;
    border-left:5px solid #333; 
    border-right:none; 
}
.screen-unit-bar.bar2,
.screen-unit-bar.bar3,
.screen-unit-bar.bar5,
.screen-unit-bar.bar6{
    left: 28px;
    top: 27px;
    width: 40px;
    transform: rotate(90deg);
    transform-origin: 0;
}
.screen-unit-bar.bar3{
    left: 102px;
}
.screen-unit-bar.bar4{
    top: 73px;
}
.screen-unit-bar.bar5,
.screen-unit-bar.bar6{
    top: 78px;
}
.screen-unit-bar.bar6{
    left: 102px;
}
.screen-unit-bar.bar7{
    top: 124px;
}

.screen-unit-bar.bar1{
    
}
.unit{
    width: 10px;
    height: 10px;
    border-radius: 100%;
    background: #fbff00;
    margin-bottom: 16px;
}
.txt-help{
  color: #999;
  margin: 10px 0 20px;
}

</style>